import React from 'react';

export default function User({ row }) {
  return (
    <div className="flex items-center">
      <img
        src={row.image}
        alt="User"
        className="w-auto h-8 mr-3 rounded-full"
      />
      {row.name}
    </div>
  );
}
